import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'

import { Route } from 'react-router-dom'
import Button from '@material-ui/core/Button';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { v4 } from 'uuid'

class TopbarComponet extends Component {
  constructor() {
    super();

  }

  componentDidMount() {}

  render() {

    return (  <div style={ { position: 'relative', backgroundColor: "transparent" } }>
                <div className="h-100 w-100" style={ { zIndex: "1", position: 'absolute', opacity: '.9', backgroundColor: "black" } }>
                </div>
                <div className="d-flex m-1 w-100 justify-content-around align-items-center" style={ { zIndex: "2", position: 'relative', backgroundColor: "transparent" } }>
                  <Button className={ `animated  rotateIn` } onClick={ (event) => window.location.hash = "conversations" } style={ { outline: 0, height: '4vh', width: "4vh", backgroundColor: 'transparent' } } variant="fab" aria-label="Settings">
                    <img style={ { zIndex: "3", color: "white", position: 'absolute', height: '3.5vh' } } src={ `./images/home.png` } />
                  </Button>
                  <img className={ `animated  rotateIn` } style={ { height: '2vh' } } src={ `./images/star.png` } />
                  <img className={ `animated  rotateIn` } style={ { height: '2vh' } } src={ `./images/sabers.svg` } />
                  <span className="animated pulse" style={ { fontSize: "2vh", color: "white", fontFamily: " 'Gloria Hallelujah', cursive" } }>jitsu chat</span>
                  <img className={ `animated  rotateIn` } style={ { height: '2vh' } } src={ `./images/sabers.svg` } />
                  <img className={ `animated  rotateIn` } style={ { height: '2vh' } } src={ `./images/star.png` } />
                  <Button className={ `animated  rotateIn` } onClick={ (event) => window.location.hash = "settings" } style={ { outline: 0, height: '4vh', width: "4vh", backgroundColor: 'transparent' } } variant="fab" aria-label="Logout">
                    <img style={ { zIndex: "3", color: "white", position: 'absolute', height: '3.5vh' } } src={ `./images/settings.png` } />
                  </Button>
                </div>
              </div> );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  locationUtil: state.locationUtil
})

const Topbar = connect(mapStateToProps, {

})(TopbarComponet)

export default Topbar


// WEBPACK FOOTER //
// ./src/Components/Topbar/index.js